import { createSelector } from 'reselect';
import { compose } from '@ngrx/store';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { environment } from '../../environments/environment';

import * as fromMobileMenu from './mobile-menu';
import * as fromSupport from './support';
import * as fromWebPlayer from './web-player';
import * as fromYoutubeModal from './youtube-modal';
import * as fromNotifications from './notifications';

import * as fromNews from './news.reducer';

export interface State {
  mobileMenu: fromMobileMenu.State;
  support: fromSupport.State;
  webPlayer: fromWebPlayer.State;
  youtubeModal: fromYoutubeModal.State;
  notifications: fromNotifications.State;
  newsData: fromNews.NewsState;
}

export const reducers: ActionReducerMap<State> = {
  mobileMenu: fromMobileMenu.reducer,
  support: fromSupport.reducer,
  webPlayer: fromWebPlayer.reducer,
  youtubeModal: fromYoutubeModal.reducer,
  notifications: fromNotifications.reducer,
  newsData: fromNews.reducer
};

export const getMobileMenuState = (state: State) => state.mobileMenu;
export const getSupportState = (state: State) => state.support;
export const getWebPlayerState = (state: State) => state.webPlayer;
export const getYoutubeModalState = (state: State) => state.youtubeModal;
export const getNotificationsState = (state: State) => state.notifications;

export const getNewsState = (state: State) => state.newsData;

export const isOpen = createSelector(getMobileMenuState, fromMobileMenu.isOpen);
export const getSport = createSelector(getSupportState, fromSupport.getSport);
export const isFootball = createSelector(
  getSupportState,
  fromSupport.isFootball
);
export const isSoccer = createSelector(getSupportState, fromSupport.isSoccer);
export const webPlayerSport = createSelector(
  getWebPlayerState,
  fromWebPlayer.webPlayerSport
);
export const webPlayerIsSet = createSelector(
  getWebPlayerState,
  fromWebPlayer.webPlayerIsSet
);
export const webPlayerDropdown = createSelector(
  getWebPlayerState,
  fromWebPlayer.webPlayerDropdown
);
export const isYoutubeModalVisible = createSelector(
  getYoutubeModalState,
  fromYoutubeModal.isVisible
);
export const youtubeVideoId = createSelector(
  getYoutubeModalState,
  fromYoutubeModal.videoId
);
export const notifications = createSelector(
  getNotificationsState,
  fromNotifications.getNotifications
);

export const getNewsArticles = createSelector(
  getNewsState,
  fromNews.getArticles
);

export const getLoadedStatus = createSelector(
  getNewsState,
  fromNews.getLoadedStatus
);

export const getNewsArticleById = (articleId: number) =>
  createSelector(getNewsArticles, (newsArticles) => {
    return newsArticles.find((article) => article.id === articleId);
  });

export const getPreviousNextArticles = (articleId: number) =>
  createSelector(
    getNewsArticles,
    getNewsArticleById(articleId),
    (newsArticles: any, currentArticle: any) => {
      const currentArticleIndex = newsArticles.indexOf(currentArticle);
      return [
        newsArticles[currentArticleIndex + 1],
        newsArticles[currentArticleIndex - 1]
      ];
    }
  );

export const getSocialMediaLinks = createSelector(
  getNewsState,
  fromNews.getSocialMediaLinks
);
